import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readAllByEmisor: emisor =>
    api
      .send({
        query: gql`
          query READ_ALL($emisor: ID!) {
            Email {
              readAllByEmisor(emisor: $emisor) {
                _id
                nombre
                estado
                inicio
                fin
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Email.readAllByEmisor),

  readById: _id =>
    api
      .send({
        query: gql`
          query readById($_id: ID!) {
            Email {
              readById(_id: $_id) {
                _id
                nombre
                estado
                inicio
                fin
                list {
                  email {
                    _id
                  }
                  cliente {
                    _id
                  }
                  nombre
                  correoElectronico
                }
              }
            }
          }
        `,
        variables: { _id }
      })
      .then(result => result.data.data.Email.readById),

  create: input =>
    api
      .send({
        query: gql`
          mutation create($input: EmailInput!) {
            Email {
              create(input: $input) {
                _id
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Email.create),

  deleteCliente: input =>
    api
      .send({
        query: gql`
          mutation deleteCliente($input: EmailInput!) {
            Email {
              deleteCliente(input: $input)
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Email.deleteCliente)


  // delete: input =>
  //   api
  //     .send({
  //       query: gql`
  //         mutation delete($input: [ID!]!) {
  //           Email {
  //             delete(input: $input) {
  //               _id
  //               state
  //               message
  //             }
  //           }
  //         }
  //       `,
  //       variables: { input }
  //     })
  //     .then(result => result.data.data.Email.delete)
}
